import { environment } from "@/lib/resources";
import { type WidgetHandle } from "@friendlycaptcha/sdk";
import { sdk } from "@internal/friendlycaptcha";

export function mountCaptcha(mount: HTMLElement): WidgetHandle {
	return sdk.createWidget({
		element: mount,
		sitekey: environment.friendlyCaptchaSitekey,
	});
}

export function mountCaptchaInForm(form: JQuery<HTMLFormElement> | HTMLFormElement): WidgetHandle {
	let container = $(form).find(".frc-captcha")[0];
	if (!container) {
		throw new Error(`kein '.frc-captcha' Element in form`);
	}

	return mountCaptcha(container);
}
